import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_SALES_COACHING_COUNT_REQUEST,
  FETCH_SALES_COACHING_COUNT_SUCCESS,
  FETCH_SALES_COACHING_COUNT_ERROR,
} from 'actionTypes'

export const countSalesCoaching = (token, params) => (dispatch) => {
  dispatch(fetchSalesCoachingRequest())

  return new Api(token, dispatch)
    .post(API_URL.SALES_COACHING_COUNT, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchSalesCoachingSuccess(response.data))
      dispatch(hideSpinner())

      return response
    })
    .catch((error) => {
      dispatch(fetchSalesCoachingError(error))
      dispatch(hideSpinner())

      return error
    })
}

export const fetchSalesCoachingRequest = () => ({
  type: FETCH_SALES_COACHING_COUNT_REQUEST,
})

export const fetchSalesCoachingSuccess = (data) => ({
  type: FETCH_SALES_COACHING_COUNT_SUCCESS,
  payload: data,
})

export const fetchSalesCoachingError = (error) => ({
  type: FETCH_SALES_COACHING_COUNT_ERROR,
  payload: error,
})
